import { branch, compose, renderComponent, withProps } from 'recompose';
import classnames from 'classnames';
import { pickBy } from 'lodash';
import PhoneInput from './PhoneInput';

export default compose(
  withProps(props => pickBy({
    className: classnames('c-input u-mt--', props.className, { 'c-input--small': props.size === 'small' }),
    placeholder: props.label,
  })),
  branch(props => (props.type === 'tel'), renderComponent(PhoneInput)),
)('input');



// WEBPACK FOOTER //
// ./src/app/components/Input.jsx